export default {
  ru: 'RU',
  en: 'ENG',
}
